/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import fireEvent from 'react-app-events/lib/fireEvent'
import {productListInformation} from '@data/fragments/products/__generated__/productListInformation'
import productListInformationFragment from '@data/fragments/products/productListInformation'
import queryObjectToString from '@helpers/misc/queryObjectToString'
import {EVENTS, sendPosthogData} from '@helpers/posthog'
import InformativeStamps from 'src/components/InformativeStamps'
import FormatNumber from '@i18n/formatNumber/Component'
import Link from 'next/link'
import {NextRouter, withRouter} from 'next/router'
import {TFunction, withTranslation} from 'next-i18next'
import slugify from 'slugify'

import RowProduct from './Cards/RowProduct'
import Image from './Image'
import styles from './styles.module.css'

export interface ProductProps {
  router: NextRouter
  product: productListInformation
  menuId: string
  location?: any
  select?: Function
  hidePrice?: boolean
  productsLayout?: string
  productCardDesign?: string
  skipRedirection?: boolean
  t: TFunction
}

export class Product extends React.Component<ProductProps> {
  static fragment = productListInformationFragment

  state = {}

  onClick = () => {
    const {product, hidePrice, router} = this.props
    if (hidePrice) {
      fireEvent('hiddenPriceProductOpened', product)
      return
    }
    sendPosthogData(EVENTS.clicked.product)

    if (this.props.select) {
      this.props.select()
      return
    }
  }

  renderPriceWithDiscounts() {
    if (this.props.hidePrice) return null
    const {finalPrice, basePrice} = this.props.product.availabilityAt
    return (
      <div>
        <div className={styles.pastPrice}>
          <FormatNumber value={basePrice} />
        </div>
        <div className={styles.price}>
          <FormatNumber value={finalPrice} />
        </div>
      </div>
    )
  }

  renderPrice() {
    const {availabilityAt} = this.props.product
    if (!availabilityAt) return
    const {hasDiscount, finalPrice, available, notAvailableMessage} = availabilityAt
    if (!available) return <div className={styles.notAvailable}>{notAvailableMessage}</div>
    if (!available)
      return (
        <div className={styles.notAvailable}>
          {this.props.t('fields.notAvailable', {ns: 'generic'})}
        </div>
      )
    if (hasDiscount) return this.renderPriceWithDiscounts()
    if (!finalPrice) return null
    if (this.props.hidePrice) return null
    return (
      <div className={styles.price}>
        <FormatNumber value={finalPrice} />
      </div>
    )
  }

  renderOutOfStock() {
    const {isOutOfStock} = this.props.product
    if (!isOutOfStock) return
    return (
      <div className={styles.outOfStock}>{this.props.t('fields.outOfStock', {ns: 'generic'})}</div>
    )
  }

  render() {
    const {product, productCardDesign, hidePrice, menuId, router} = this.props

    const description = product.description ? product.description.split('\n\n')[0] : ''

    const className = [this.props.productsLayout === 'compact' ? styles.compact : styles.container]
    if (product.isOutOfStock) {
      className.push(styles.isOutOfStock)
    }

    const query = queryObjectToString(router.query)
    const href = this.props.skipRedirection
      ? '#'
      : `/pedir/${product._id}/${slugify(product.name, {
          lower: true,
          strict: true
        })}${query ? `?${query}` : ''}`
    const informativeStampsList = product?.informativeStamps?.slice(0, 3)
    const info = (
      <div className={styles.info}>
        <div className={styles.nameAndDescription}>
          <span className={styles.name}>{product.name}</span>
        </div>
        <div>
          <InformativeStamps stamps={informativeStampsList} iconOnly={true} />
          <div className={styles.nameAndDescription}>
            {this.props.productsLayout === 'compact' ? null : (
              <>
                <br />
                <span className={styles.description}>{description}</span>
              </>
            )}
          </div>
        </div>
        <div className={styles.space} />
        {this.renderPrice()}
      </div>
    )

    const image = <Image product={product} />

    const isRow = [
      'row',
      'row-inverse',
      'row-inverse-fast',
      'row-fast',
      'row-inverse-fast'
    ].includes(productCardDesign)

    if (isRow) {
      return (
        <RowProduct
          image={image}
          onClick={this.onClick}
          href={href}
          product={product}
          description={description}
          menuId={menuId}
          reverse={['row-inverse', 'row-inverse-fast'].includes(productCardDesign)}
          fastAddToCart={['row-fast', 'row-inverse-fast'].includes(productCardDesign)}
          hidePrice={hidePrice}
        />
      )
    }

    return this.props.productsLayout === 'compact' ? (
      <Link href={href} scroll={false}>
        <a className={className.join(' ')} onClick={this.onClick}>
          {this.renderOutOfStock()}
          <div className={styles.img}>{image}</div>
          {info}
        </a>
      </Link>
    ) : (
      <Link href={href} scroll={false}>
        <a className={className.join(' ')} onClick={this.onClick}>
          {this.renderOutOfStock()}
          {info}
          <div className={styles.img}>{image}</div>
        </a>
      </Link>
    )
  }
}

export default withTranslation()(withRouter<ProductProps>(Product))
